/* eslint-disable camelcase */
import type {AccordionsEnabled, BooleanFields, SvgInHtml} from '../accordions';

export type LegacyObject = {
	enabled_accordions: AccordionsEnabled;
	accordion: {
		init: ( force?: boolean ) => void;
		isChecked: ( widgetId: string, option: BooleanFields ) => boolean;
		_expand_sub_menu: ( $menuItem: JQuery<HTMLLIElement>, $icon: JQuery<SvgInHtml> ) => void;
	}
}

type Props = LegacyObject['accordion'] & {
	accordions: AccordionsEnabled;
}


export function getLegacyObject(): LegacyObject {
	if ( 'undefined' === typeof window.asm_pro ) {
		throw new Error( 'window.asm_pro is not defined. Did you forget to call `legacyAsmPro()`?' );
	}
	return window.asm_pro;
}


/**
 * Enable the legacy global variables.
 *
 * Exposes window.asm_pro and window.asm_pro.accordion for backward
 * compatibility of customizations.
 *
 * @notice You should not be using the `window.asm_pro` global variable.
 */
export default ( {accordions, _expand_sub_menu, init, isChecked}: Props ): void => {
	/**
	 * Translate old support requests into the new structure within reason.
	 * Some will no longer work which will require the user to update their
	 * customizations.
	 */
	const legacyStructure = {
		init( force: boolean = false ) {
			console.error( 'Using `asm_pro` global variable is deprecated. Use `advancedSidebarMenuPro.accordions.init` method instead.' );
			init( force );
		},
		_expand_sub_menu: ( $menuItem: JQuery<HTMLLIElement>, $icon: JQuery<SvgInHtml> ) => {
			console.error( 'Using `asm_pro` global variable is deprecated. Use `advancedSidebarMenuPro.accordions.expandSubMenu` method instead.' );
			// Translate an old span to new SVG.
			if ( 0 === $icon.length ) {
				$icon = $menuItem.find<SvgInHtml>( '.advanced-sidebar-icon' ).first();
			}
			_expand_sub_menu( $menuItem, $icon );
		},
		isChecked,
	};

	window.asm_pro = window.asm_pro || {
		enabled_accordions: {},
		accordion: legacyStructure,
	};
	window.asm_pro.accordion = legacyStructure;
	window.asm_pro.enabled_accordions = accordions;
}
